import React from 'react';
import ReactDOM from 'react-dom';
import 'opensans-npm-webfont';
import './styles/App.css';
import './styles/buttons.css';
import './styles/mobile.css';
import './styles/result.css';
import './styles/splash.css';
import './styles/tooltip.css';
import './styles/video.css';
import './styles/wechat-qr.css';
import App from './scenes/App';
import './index.css';

// SET LANGUAGE
let lang = navigator.language || navigator.userLanguage;

window.userLanguage = localStorage.getItem( 'userLanguage' ) || ( lang.indexOf( 'en' ) > -1 ? 'EN' : 'CN' );

// INIT REACT APP
ReactDOM.render(<App />, document.getElementById('root'));

// LOAD RAVER (SENTRY TRACKING)
window.Raven = require( 'raven-js' );

window.Raven.config( "https://16e61043af2946e1ac8e7416378b76ee@sentry.io/215124" ).install();


// WEBPACK FOOTER //
// ./src/app/index.js